var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _vm.processing && !_vm.newFormsProcessed
        ? _c(
            "b-button",
            {
              staticClass: "new_forms_processed",
              attrs: { size: "sm", variant: "secondary" }
            },
            [
              _vm._v(_vm._s(this.$t("FORMS.PROCESSING_STAT")) + " "),
              _c("i", { staticClass: "fa fa-spin fa-spinner" })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.newFormsProcessed > 0
        ? _c(
            "b-button",
            {
              staticClass: "new_forms_processed",
              attrs: { size: "sm", variant: "secondary" },
              on: { click: _vm.handleRefresh }
            },
            [
              _vm._v(
                _vm._s(_vm.newFormsProcessed) +
                  "  " +
                  _vm._s(
                    _vm.newFormsProcessed > 1
                      ? this.$t("FORMS.PROCESSED_STAT_MANY")
                      : this.$t("FORMS.PROCESSED_STAT_ONE")
                  ) +
                  "  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-tabs",
        {
          staticClass: "processed-form",
          model: {
            value: _vm.tabIndex,
            callback: function($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex"
          }
        },
        [
          _c("FormsSearchBar", {
            attrs: {
              title: _vm.$t("WORKFLOW.PROCESSED_FORMS"),
              eventBus: _vm.eventBus,
              order: _vm.order,
              tabIndex: _vm.tabIndex
            },
            on: {
              filterInput: _vm.setFilter,
              refreshTab: _vm.refreshTab,
              applyFilters: _vm.applyFilters
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.tabs, function(tab, index) {
            return _c(
              "b-tab",
              {
                key: tab.id,
                attrs: {
                  title: _vm._f("titlize")(_vm.getTabName(tab.name)),
                  disabled: _vm.disable_tab
                },
                on: {
                  click: function($event) {
                    _vm.handleTabChange(tab.role_order)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "forms-table" },
                  [
                    _vm.formsLoaded
                      ? _c("b-table", {
                          attrs: {
                            hover: "",
                            striped: "",
                            "show-empty": "",
                            "empty-text": _vm.$t("COMMON.NO_RECORD"),
                            responsive: "sm",
                            items: _vm.$store.getters.getProcessedData,
                            fields: _vm.tableFields,
                            "sort-by": _vm.sortBy,
                            "sort-desc": _vm.sortDesc,
                            "sort-compare": _vm.sortCompare
                          },
                          on: {
                            "update:sortBy": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sortDesc": function($event) {
                              _vm.sortDesc = $event
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "HEAD_group_id",
                              fn: function(data) {
                                return [
                                  _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                                ]
                              }
                            },
                            {
                              key: "HEAD_title",
                              fn: function(data) {
                                return [
                                  _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                                ]
                              }
                            },
                            {
                              key: "title",
                              fn: function(data) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.viewport",
                                          modifiers: { viewport: true }
                                        }
                                      ],
                                      attrs: { title: data.item.title }
                                    },
                                    [_vm._v(_vm._s(data.item.title))]
                                  )
                                ]
                              }
                            },
                            {
                              key: "HEAD_document_type",
                              fn: function(data) {
                                return [
                                  _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                                ]
                              }
                            },
                            {
                              key: "HEAD_processed",
                              fn: function(data) {
                                return [
                                  _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                                ]
                              }
                            },
                            {
                              key: "HEAD_rejected",
                              fn: function(data) {
                                return [
                                  _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                                ]
                              }
                            },
                            {
                              key: "HEAD_match_type",
                              fn: function(data) {
                                return [
                                  _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                                ]
                              }
                            },
                            {
                              key: "HEAD_updated_at",
                              fn: function(data) {
                                return [
                                  _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                                ]
                              }
                            },
                            {
                              key: "updated_at",
                              fn: function(data) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.viewport",
                                          modifiers: { viewport: true }
                                        }
                                      ],
                                      attrs: { title: data.item.updated_at }
                                    },
                                    [_vm._v(_vm._s(data.item.updated_at))]
                                  )
                                ]
                              }
                            },
                            {
                              key: "HEAD_created_at",
                              fn: function(data) {
                                return [
                                  _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                                ]
                              }
                            },
                            {
                              key: "created_at",
                              fn: function(data) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.viewport",
                                          modifiers: { viewport: true }
                                        }
                                      ],
                                      attrs: { title: data.item.created_at }
                                    },
                                    [_vm._v(_vm._s(data.item.created_at))]
                                  )
                                ]
                              }
                            },
                            {
                              key: "HEAD_total_page_count",
                              fn: function(data) {
                                return [
                                  _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                                ]
                              }
                            },
                            {
                              key: "HEAD_forms_doc_status",
                              fn: function(data) {
                                return [
                                  _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                                ]
                              }
                            },
                            {
                              key: "forms_doc_status",
                              fn: function(data) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.viewport",
                                          modifiers: { viewport: true }
                                        }
                                      ],
                                      attrs: {
                                        title:
                                          _vm.formDocumnetStatus[
                                            data.item.forms_doc_status
                                          ]
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formDocumnetStatus[
                                            data.item.forms_doc_status
                                          ]
                                        )
                                      )
                                    ]
                                  )
                                ]
                              }
                            },
                            {
                              key: "HEAD_download_link",
                              fn: function(data) {
                                return [
                                  _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                                ]
                              }
                            },
                            {
                              key: "download_link",
                              fn: function(data) {
                                return [
                                  data.item.first_form_id &&
                                  data.item.form_doc_lock === false &&
                                  _vm.order !== -2 &&
                                  _vm.order !== -1 &&
                                  _vm.order !== 2
                                    ? _c(
                                        "div",
                                        { staticClass: "btn-group" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "Verification",
                                                  params: {
                                                    id: data.item.first_form_id
                                                  }
                                                }
                                              }
                                            },
                                            [
                                              _vm
                                                .allowedExports(
                                                  data.item.match_type,
                                                  index,
                                                  data.item.status,
                                                  data.item.forms_doc_status
                                                )
                                                .indexOf("analysis") >= 0 &&
                                              !data.item.is_rejected
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary btn-sm",
                                                      class: _vm.getCSS(
                                                        data.item.match_type,
                                                        index,
                                                        data.item.status,
                                                        "analysis"
                                                      ),
                                                      attrs: {
                                                        variant: "secondary"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "WORKFLOW.ANALYSIS"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm
                                            .allowedExports(
                                              data.item.match_type,
                                              index,
                                              data.item.status,
                                              data.item.forms_doc_status
                                            )
                                            .indexOf("salesforce") >= 0 &&
                                          data.item.forms_doc_status !==
                                            _vm.formDocStatusEnums[
                                              "PCSUCCESS"
                                            ] &&
                                          !data.item.is_rejected
                                            ? _c(
                                                "b-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover.viewport",
                                                      modifiers: {
                                                        hover: true,
                                                        viewport: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "btn btn-primary btn-sm",
                                                  class: _vm.getCSS(
                                                    data.item.match_type,
                                                    index,
                                                    data.item.status,
                                                    "salesforce"
                                                  ),
                                                  attrs: {
                                                    disabled:
                                                      data.item
                                                        .sf_export_status ===
                                                      true,
                                                    variant: "primary",
                                                    title: _vm.$t(
                                                      "COMMON.SLSFRC"
                                                    )
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.processJson(
                                                        data.item,
                                                        "salesforce"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    ref:
                                                      "export-salesforce-" +
                                                      index +
                                                      "-" +
                                                      data.item.id,
                                                    refInFor: true,
                                                    staticClass:
                                                      "icon-cloud-upload"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    ref:
                                                      "spinner-salesforce-" +
                                                      index +
                                                      "-" +
                                                      data.item.id,
                                                    refInFor: true,
                                                    staticClass:
                                                      "fa fa-spin fa-spinner hide"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm
                                            .allowedExports(
                                              data.item.match_type,
                                              index,
                                              data.item.status,
                                              data.item.forms_doc_status
                                            )
                                            .indexOf("reject") >= 0 &&
                                          !data.item.is_rejected &&
                                          data.item.first_form_id &&
                                          !data.item.form_doc_lock &&
                                          _vm.formDocumnetStatus[
                                            data.item.forms_doc_status
                                          ] !== "Completed"
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "btn btn-primary btn-sm ml-1",
                                                  attrs: {
                                                    variant: "secondary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.showRejectFormModal(
                                                        data.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Reject\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm
                                            .allowedExports(
                                              data.item.match_type,
                                              index,
                                              data.item.status,
                                              data.item.forms_doc_status
                                            )
                                            .indexOf("recall") >= 0 &&
                                          data.item.is_rejected &&
                                          data.item.first_form_id
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "btn btn-primary btn-sm",
                                                  attrs: {
                                                    variant: "secondary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.changeRejectStatus(
                                                        data.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Recall\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : data.item.form_doc_lock
                                      ? _c(
                                          "div",
                                          { staticClass: "btn-group" },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "btn btn-primary btn-sm",
                                                attrs: { variant: "dark" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.multipleUser(
                                                      data.item.id,
                                                      data.item.user_name
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "WORKFLOW.LOCK_TITLE",
                                                        {
                                                          userName:
                                                            data.item.user_name
                                                        }
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-unlock-alt",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : data.item.match_type === "TRIAGING" &&
                                        data.item.forms_doc_status ===
                                          _vm.formDocStatusEnums["COMPLETED"]
                                        ? _c(
                                            "div",
                                            { staticClass: "btn-group" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "text-center" },
                                                [
                                                  _c("span", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "green",
                                                          "font-size": "24px",
                                                          padding: "2px"
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-check-circle fa-sm"
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        : data.item.sf_export_status === true
                                          ? _c(
                                              "div",
                                              { staticClass: "btn-group" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-center"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            color: "green",
                                                            "font-size": "24px",
                                                            padding: "2px"
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-check-circle fa-sm"
                                                          })
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover.viewport",
                                                        modifiers: {
                                                          hover: true,
                                                          viewport: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "last-button btn-sm",
                                                    staticStyle: {
                                                      "border-radius": "0px"
                                                    },
                                                    attrs: {
                                                      variant: "dark",
                                                      title: "View Record"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.viewRecord(
                                                          data.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-external-link",
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : !data.item.first_form_id
                                            ? _c(
                                                "div",
                                                { staticClass: "btn-group" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "text-center"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                              "font-size":
                                                                "24px",
                                                              padding: "2px"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-check-circle"
                                                            })
                                                          ]
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "b-tooltip",
                                                          rawName:
                                                            "v-b-tooltip.hover.viewport",
                                                          modifiers: {
                                                            hover: true,
                                                            viewport: true
                                                          }
                                                        }
                                                      ],
                                                      staticClass:
                                                        "last-button btn-sm",
                                                      staticStyle: {
                                                        "border-radius": "0px"
                                                      },
                                                      attrs: {
                                                        variant: "dark",
                                                        title: "View Record"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.viewRecord(
                                                            data.item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-external-link",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "btn-group" },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: {
                                                          name: "Verification",
                                                          params: {
                                                            id:
                                                              data.item
                                                                .first_form_id
                                                          }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm
                                                        .allowedExports(
                                                          data.item.match_type,
                                                          index,
                                                          data.item.status,
                                                          data.item
                                                            .forms_doc_status
                                                        )
                                                        .indexOf("analysis") >=
                                                        0 &&
                                                      !data.item.is_rejected
                                                        ? _c(
                                                            "b-button",
                                                            {
                                                              staticClass:
                                                                "btn btn-primary btn-sm",
                                                              class: _vm.getCSS(
                                                                data.item
                                                                  .match_type,
                                                                index,
                                                                data.item
                                                                  .status,
                                                                "analysis"
                                                              ),
                                                              attrs: {
                                                                variant:
                                                                  "secondary"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "WORKFLOW.ANALYSIS"
                                                                    )
                                                                  ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm
                                                    .allowedExports(
                                                      data.item.match_type,
                                                      index,
                                                      data.item.status,
                                                      data.item.forms_doc_status
                                                    )
                                                    .indexOf("salesforce") >= 0
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.hover.viewport",
                                                              modifiers: {
                                                                hover: true,
                                                                viewport: true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "btn btn-primary btn-sm",
                                                          class: _vm.getCSS(
                                                            data.item
                                                              .match_type,
                                                            index,
                                                            data.item.status,
                                                            "salesforce"
                                                          ),
                                                          attrs: {
                                                            disabled:
                                                              data.item
                                                                .sf_export_status ===
                                                              true,
                                                            variant: "primary",
                                                            title: _vm.$t(
                                                              "COMMON.SLSFRC"
                                                            )
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.processJson(
                                                                data.item,
                                                                "salesforce"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            ref:
                                                              "export-salesforce-" +
                                                              index +
                                                              "-" +
                                                              data.item.id,
                                                            refInFor: true,
                                                            staticClass:
                                                              "icon-cloud-upload"
                                                          }),
                                                          _vm._v(" "),
                                                          _c("i", {
                                                            ref:
                                                              "spinner-salesforce-" +
                                                              index +
                                                              "-" +
                                                              data.item.id,
                                                            refInFor: true,
                                                            staticClass:
                                                              "fa fa-spin fa-spinner hide"
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  (data.item.match_type ===
                                                    "TRIAGING" ||
                                                    data.item.match_type ===
                                                      "ESF_TRIAGING" ||
                                                    data.item.status ===
                                                      "ESF_TRIAGING" ||
                                                    _vm.order === 2 ||
                                                    _vm.order === -2) &&
                                                  data.item.is_rejected ===
                                                    false
                                                    ? _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to:
                                                              _vm.order === -2
                                                                ? "modify/" +
                                                                  data.item.id
                                                                : _vm.order ===
                                                                  2
                                                                  ? "esf_triaging/" +
                                                                    data.item.id
                                                                  : "modify/" +
                                                                    data.item.id
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-button",
                                                            {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "b-tooltip",
                                                                  rawName:
                                                                    "v-b-tooltip.hover.viewport",
                                                                  modifiers: {
                                                                    hover: true,
                                                                    viewport: true
                                                                  }
                                                                }
                                                              ],
                                                              staticClass:
                                                                "btn btn-primary btn-sm",
                                                              attrs: {
                                                                id:
                                                                  "tooltip-target-1",
                                                                variant:
                                                                  "secondary",
                                                                title: "Show"
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-eye"
                                                              })
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.exportRotatedDocs(
                                                    data.item,
                                                    index
                                                  ) && index === 0
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.hover.viewport",
                                                              modifiers: {
                                                                hover: true,
                                                                viewport: true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "btn btn-primary btn-sm",
                                                          class: _vm.getCSS(
                                                            data.item
                                                              .match_type,
                                                            index,
                                                            data.item.status
                                                          ),
                                                          attrs: {
                                                            disabled:
                                                              data.item
                                                                .sf_export_status ===
                                                              true,
                                                            variant: "primary",
                                                            title: _vm.$t(
                                                              "COMMON.SLSFRC"
                                                            )
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.processRotatedDoc(
                                                                data.item,
                                                                "rotated_docs_sf"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            ref:
                                                              "export-rotated_docs_sf-" +
                                                              data.item.id,
                                                            refInFor: true,
                                                            staticClass:
                                                              "icon-cloud-upload"
                                                          }),
                                                          _vm._v(" "),
                                                          _c("i", {
                                                            ref:
                                                              "spinner-rotated_docs_sf-" +
                                                              data.item.id,
                                                            refInFor: true,
                                                            staticClass:
                                                              "fa fa-spin fa-spinner hide"
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm
                                                    .allowedExports(
                                                      data.item.match_type,
                                                      index,
                                                      data.item.status,
                                                      data.item.forms_doc_status
                                                    )
                                                    .indexOf("reprocess") >= 0
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "btn btn-sm btn-primary",
                                                          attrs: {
                                                            variant: "primary",
                                                            disabled:
                                                              data.item
                                                                .retry_count >=
                                                                3 ||
                                                              data.item
                                                                .is_rejected
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.confirmReprocess(
                                                                data.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "b-tooltip",
                                                                rawName:
                                                                  "v-b-tooltip.hover.viewport",
                                                                modifiers: {
                                                                  hover: true,
                                                                  viewport: true
                                                                }
                                                              }
                                                            ],
                                                            staticClass:
                                                              "icon-refresh",
                                                            attrs: {
                                                              title:
                                                                data.item
                                                                  .retry_count >=
                                                                3
                                                                  ? _vm.$t(
                                                                      "WORKFLOW.MAX_RETRIES"
                                                                    )
                                                                  : _vm.$t(
                                                                      "WORKFLOW.REPROCESS"
                                                                    )
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm
                                                    .allowedExports(
                                                      data.item.match_type,
                                                      index,
                                                      data.item.status,
                                                      data.item.forms_doc_status
                                                    )
                                                    .indexOf("moveToMatched") >=
                                                  0
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.hover.viewport",
                                                              modifiers: {
                                                                hover: true,
                                                                viewport: true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "btn btn-primary btn-sm",
                                                          attrs: {
                                                            variant:
                                                              "secondary",
                                                            title: _vm.$t(
                                                              "WORKFLOW.MOVE_TO_MATCHED"
                                                            ),
                                                            disabled:
                                                              data.item
                                                                .is_rejected
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.moveToMatched(
                                                                data.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-reply"
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm
                                                    .allowedExports(
                                                      data.item.match_type,
                                                      index,
                                                      data.item.status,
                                                      data.item.forms_doc_status
                                                    )
                                                    .indexOf("reject") >= 0 &&
                                                  !data.item.is_rejected &&
                                                  data.item.first_form_id &&
                                                  !data.item.form_doc_lock &&
                                                  _vm.formDocumnetStatus[
                                                    data.item.forms_doc_status
                                                  ] !== "Completed"
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "btn btn-primary btn-sm ml-1",
                                                          attrs: {
                                                            variant: "secondary"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.showRejectFormModal(
                                                                data.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  Reject\n              "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm
                                                    .allowedExports(
                                                      data.item.match_type,
                                                      index,
                                                      data.item.status,
                                                      data.item.forms_doc_status
                                                    )
                                                    .indexOf("recall") >= 0 &&
                                                  data.item.is_rejected &&
                                                  data.item.first_form_id
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "btn btn-primary btn-sm",
                                                          attrs: {
                                                            variant: "secondary"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.changeRejectStatus(
                                                                data.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  Recall\n              "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                ]
                              }
                            }
                          ])
                        })
                      : _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-card",
                                  [
                                    _c(
                                      "content-placeholders",
                                      [
                                        _c("content-placeholders-img", {
                                          style: { height: "400px" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c(
                      "infinite-loading",
                      {
                        ref: "infiniteLoading",
                        refInFor: true,
                        attrs: {
                          identifier: _vm.infiniteId,
                          distance: _vm.distance,
                          spinner: "spiral"
                        },
                        on: { infinite: _vm.infiniteHandler }
                      },
                      [
                        _c("div", {
                          attrs: { slot: "no-more" },
                          slot: "no-more"
                        }),
                        _vm._v(" "),
                        _c("div", {
                          attrs: { slot: "no-results" },
                          slot: "no-results"
                        })
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "fhirModal",
          attrs: {
            "hide-header-close": "",
            centered: "",
            title: "FHIR data",
            "ok-only": ""
          },
          on: { ok: _vm.clearFhirData }
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c("strong", [_vm._v("Demographics")]),
              _vm._v(" "),
              _vm._l(_vm.fhirValues["demographics"], function(
                value,
                key,
                index
              ) {
                return _c(
                  "b-row",
                  {
                    key: "demographics" + index,
                    staticClass: "mb-1 text-center"
                  },
                  [
                    _c("b-col", { attrs: { cols: "6" } }, [
                      _vm._v(_vm._s(_vm._f("capitalize")(key)) + " ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticStyle: { "word-wrap": "break-word" },
                        attrs: { cols: "6" }
                      },
                      [_vm._v(_vm._s(value))]
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("strong", [_vm._v("Orders")]),
              _vm._v(" "),
              _vm._l(_vm.fhirValues["orders"], function(value, key, index) {
                return _c(
                  "b-row",
                  { key: "orders" + index, staticClass: "mb-1 text-center" },
                  [
                    _c("b-col", { attrs: { cols: "6" } }, [
                      _vm._v(_vm._s(_vm._f("capitalize")(key)) + " ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticStyle: { "word-wrap": "break-word" },
                        attrs: { cols: "6" }
                      },
                      [_vm._v(_vm._s(value))]
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("strong", [_vm._v("Diagnostics")]),
              _vm._v(" "),
              _vm._l(_vm.fhirValues["diagnostics"], function(
                value,
                key,
                index
              ) {
                return _c(
                  "b-row",
                  {
                    key: "diagnostics" + index,
                    staticClass: "mb-1 text-center"
                  },
                  [
                    _c("b-col", { attrs: { cols: "6" } }, [
                      _vm._v(_vm._s(_vm._f("capitalize")(key)) + " ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticStyle: { "word-wrap": "break-word" },
                        attrs: { cols: "6" }
                      },
                      [_vm._v(_vm._s(value))]
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "validationErrorModal",
          attrs: {
            "hide-header-close": "",
            centered: "",
            title: "Export errors",
            "ok-only": ""
          },
          on: { ok: _vm.clearValidationErrorData }
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              !_vm.errorKeyAbsent ? _c("strong", [_vm._v("Errors")]) : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.validationErrors, function(value, index) {
                return _vm.errorKeyAbsent
                  ? _c(
                      "b-row",
                      { key: index, staticClass: "mb-1 text-center" },
                      [
                        _c(
                          "b-col",
                          {
                            staticStyle: { "word-wrap": "break-word" },
                            attrs: { cols: "12" }
                          },
                          [_vm._v(_vm._s(value.reason))]
                        )
                      ],
                      1
                    )
                  : _vm._l(_vm.validationErrors, function(value, key, index) {
                      return _c(
                        "b-row",
                        { key: key, staticClass: "mb-1 text-left" },
                        [
                          _c("b-col", { attrs: { cols: "5" } }, [
                            _vm._v(_vm._s(value.key) + " ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticStyle: { "word-wrap": "break-word" },
                              attrs: { cols: "7" }
                            },
                            [_vm._v(_vm._s(value.reason))]
                          )
                        ],
                        1
                      )
                    })
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "exportErrorModal",
          attrs: {
            "hide-header-close": "",
            centered: "",
            title: "Export errors"
          }
        },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            this.$store.getters.exportErrors &&
            this.$store.getters.exportErrors.length > 0
              ? _c(
                  "div",
                  { staticClass: "mb-3 error_listing" },
                  _vm._l(this.$store.getters.exportErrors, function(
                    error,
                    index
                  ) {
                    return _c(
                      "b-row",
                      { key: index },
                      [
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _vm._v("\n          " + _vm._s(error) + "\n        ")
                        ])
                      ],
                      1
                    )
                  })
                )
              : _vm._e(),
            _vm._v(" "),
            this.$store.getters.otherMedErrors &&
            this.$store.getters.otherMedErrors.length > 0
              ? _c(
                  "div",
                  { staticClass: "mb-3 error_listing" },
                  _vm._l(this.$store.getters.otherMedErrors, function(
                    status,
                    index
                  ) {
                    return _c(
                      "b-row",
                      { key: index, staticStyle: { "text-align": "left" } },
                      [
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(index + 1) +
                              "." +
                              _vm._s(status) +
                              "\n        "
                          )
                        ])
                      ],
                      1
                    )
                  })
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "secondary" },
                  on: { click: _vm.clearExportErrorData }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.OKAY")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "reprocessModal",
          attrs: {
            "hide-header-close": "",
            centered: "",
            title: _vm.$t("WORKFLOW.REPROCESS"),
            "ok-title": _vm.$t("WORKFLOW.REPROCESS"),
            "ok-variant": "secondary",
            "cancel-title": _vm.$t("COMMON.CANCEL"),
            "cancel-variant": "light"
          },
          on: { ok: _vm.reprocessFormDoc }
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-input-group",
                [
                  _c("b-col", { staticClass: "p-1 col-4 col-sm-4" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("COMMON.TITLE")))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "p-1 col-8 col-sm-8" },
                    [
                      _c("b-form-input", {
                        staticClass: "reprocess-input",
                        attrs: { value: _vm.selectedFormTitle, disabled: "" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-input-group",
                [
                  _c("b-col", { staticClass: "p-1 col-4 col-sm-4" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("FORMS.PROCESS_TYPE")) + ":")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "p-1 col-4 col-sm-8" },
                    [
                      _c("b-form-select", {
                        staticClass: "reprocess-input",
                        attrs: {
                          plain: true,
                          options: _vm.setOptions,
                          placeholder: _vm.$t("FORMS.MATCH")
                        },
                        on: {
                          input: function($event) {
                            _vm.handleMatchSelect()
                          }
                        },
                        model: {
                          value: _vm.match_type,
                          callback: function($$v) {
                            _vm.match_type = $$v
                          },
                          expression: "match_type"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.canShowImgPreview
                ? _c(
                    "b-input-group",
                    [
                      _c("b-col", { staticClass: "p-1 col-4 col-sm-4" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("FORMS.FORCED_TEMPLATE")) + ":")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "p-1 col-8 col-sm-4" },
                        [
                          _c("b-form-select", {
                            staticClass: "reprocess-input",
                            attrs: {
                              plain: true,
                              options: _vm.templateOptions,
                              placeholder: _vm.$t("FORMS.TEMPLATE")
                            },
                            on: {
                              input: function($event) {
                                _vm.handleTemplateSelect()
                              }
                            },
                            model: {
                              value: _vm.forced_template_doc_id,
                              callback: function($$v) {
                                _vm.forced_template_doc_id = $$v
                              },
                              expression: "forced_template_doc_id"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "p-1 col-12 col-sm-4" },
                        [
                          _c("zoom-center-transition", [
                            _c("img", {
                              staticClass: "shadow preview-image",
                              attrs: { src: _vm.previewImageUrl }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "processedformsInfo",
          attrs: {
            size: "lg",
            title: _vm.$t("WORKFLOW.FORM_INFO_HEADER"),
            "no-close-on-esc": "",
            "hide-header-close": "",
            "no-close-on-backdrop": "",
            centered: ""
          }
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mb-1 text-center" },
                [
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c("strong", [_vm._v("Processed Form Ids")])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c("strong", [_vm._v("Title")])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c("strong", [_vm._v("Process Type")])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c("strong", [_vm._v("Export To Salesforce")])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.processed_form_info, function(info) {
                return _c(
                  "b-row",
                  { key: info.id, staticClass: "mb-1 text-center" },
                  [
                    _c("b-col", { attrs: { cols: "3" } }, [
                      _vm._v(_vm._s(info.id) + " ")
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "3" } }, [
                      _vm._v(_vm._s(info.title) + " ")
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "3" } }, [
                      _vm._v(_vm._s(info.match_type) + " ")
                    ]),
                    _vm._v(" "),
                    info.is_export === true
                      ? _c("b-col", { attrs: { cols: "3" } }, [
                          _vm._v(" Export Sucessfull ")
                        ])
                      : info.is_export === false
                        ? _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v(" Export Unsucessfull ")
                          ])
                        : info.is_export === null
                          ? _c("b-col", { attrs: { cols: "3" } }, [
                              _vm._v(" Not Yet Exported ")
                            ])
                          : _vm._e()
                  ],
                  1
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "secondary" },
                  on: { click: _vm.showFormInfo }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.OKAY")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "salesforceReport",
          attrs: {
            size: "md",
            title: "Record Status",
            "hide-footer": "",
            centered: ""
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "left", overflow: "auto" } },
            [
              _c(
                "table",
                { staticClass: "result", staticStyle: { width: "100%" } },
                [
                  _c(
                    "tr",
                    {
                      staticClass: "result",
                      staticStyle: { "background-color": "rgb(168 174 179)" }
                    },
                    [
                      _c("th", { staticClass: "result" }, [_vm._v(" S.No ")]),
                      _vm._v(" "),
                      _c("th", { staticClass: "result" }, [
                        _vm._v(" Record Type ")
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "result" }, [_vm._v(" Status ")])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.salesforceResponse, function(
                    record,
                    record_type,
                    index
                  ) {
                    return _c("tr", [
                      _c("td", { staticClass: "result" }, [
                        _vm._v(_vm._s(index + 1))
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "result",
                          staticStyle: { "text-align": "left" }
                        },
                        [
                          record.success && record.pc_url
                            ? _c(
                                "a",
                                {
                                  staticStyle: { color: "blue" },
                                  attrs: {
                                    target: "_blank",
                                    href: record.pc_url
                                  }
                                },
                                [_vm._v(_vm._s(record_type))]
                              )
                            : _c("a", [_vm._v(_vm._s(record_type))])
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", { staticClass: "result" }, [
                        record.pc_url && record.success
                          ? _c("a", [_vm._v("success")])
                          : _c("a", [_vm._v("failed")])
                      ])
                    ])
                  })
                ],
                2
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "formDelModal",
          attrs: {
            "hide-header-close": "",
            centered: "",
            title: _vm.$t("COMMON.DELETE_CONFIRM"),
            "ok-title": _vm.$t("COMMON.DELETE"),
            "cancel-title": _vm.$t("COMMON.CANCEL"),
            "ok-variant": "secondary",
            "cancel-variant": "light"
          },
          on: { ok: _vm.deleteFormDoc }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("WORKFLOW.DELETE_FORM", {
                  FORM_TITLE: _vm.selectedFormTitle
                })
              ) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _vm.isAdminRole
        ? _c(
            "b-modal",
            {
              ref: "lockedFormDocWarning",
              attrs: {
                title: _vm.$t("FORMS.MULTI_USER_MODAL"),
                "ok-title": _vm.$t("COMMON.YES"),
                "cancel-title": _vm.$t("COMMON.NO"),
                "ok-variant": "secondary",
                "cancel-variant": "light",
                "hide-header-close": "",
                centered: ""
              },
              on: {
                ok: function($event) {
                  _vm.releaseFormDoc()
                },
                cancel: function($event) {
                  _vm.stayWithFormDoc()
                }
              }
            },
            [_c("strong", [_vm._v(_vm._s(_vm.$t("WORKFLOW.LOCK_ALERT_MSG")))])]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "rejectFormDoc",
          attrs: {
            "hide-header-close": "",
            title: "Reject Form",
            "header-bg-variant": "light",
            centered: ""
          }
        },
        [
          _c(
            "b-card",
            { staticClass: "mt-3" },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../static/img/exclamation.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("h5", [_vm._v("Do you want to reject this document?")])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "danger" },
                  on: {
                    click: function($event) {
                      _vm.rejectForm(_vm.currentFormDoc)
                    }
                  }
                },
                [_vm._v(" Confirm ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: { click: _vm.hideRejectFormDocModal }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CANCEL")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "escalatedFormDoc",
          attrs: {
            "hide-header-close": "",
            title: "Error",
            "header-bg-variant": "light",
            centered: "",
            "ok-only": ""
          },
          on: { ok: _vm.hideEscalatedFormDocModal }
        },
        [
          _c(
            "b-card",
            { staticClass: "mt-3" },
            [
              _c(
                "b-row",
                { staticClass: "form-group", staticStyle: { height: "5px" } },
                [
                  _c("p", { staticStyle: { "font-size": "16px" } }, [
                    _vm._v(" " + _vm._s(_vm.errorMessage))
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "rejectedDocWarn",
          attrs: {
            "hide-header-close": "",
            title: "Alert",
            "header-bg-variant": "light",
            centered: ""
          }
        },
        [
          _c("div", {
            staticClass: "warning-con warning-bg-con-color mb-2",
            domProps: { innerHTML: _vm._s(_vm.svg.warningAlert) }
          }),
          _vm._v(" "),
          _c("h5", [
            _vm._v("This form has already been rejected. Click "),
            _c("b", [_vm._v("Transcribe and Rotate")]),
            _vm._v(" in Salesforce again to reprocess it.")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  staticClass: "custom-btn",
                  attrs: { size: "sm" },
                  on: { click: _vm.hideRejectedDocWarnModel }
                },
                [_vm._v("Okay")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f221814a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f221814a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/process/ProcessedForms.vue
// module id = 1152
// module chunks = 2